import { YearsService } from './services/years.service';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';

export let Links: any[] = [{
    firstLink: ["info", "About"],
    secondLink: [{
        url: "info",
        data: "About us",
        innerLink: []
      },
      {
        url: "equip",
        data: "Equipments",
        innerLink: []
      },
      {
        url: "admission",
        data: "Admission",
        innerLink: []
      },
      {
        url: "partners",
        data: "Partners",
        innerLink: []
      },
      {
        url: "sponsorship",
        data: "Sponsorship",
        innerLink: []
      }
    ]
  },
  {
    firstLink: ["people", "People"],
    secondLink: [{
        url: "people",
        data: "Faculty",
        scroll: "faculty",
      },
      {
        url: "people",
        data: "Post Doctors",
        scroll: "post",
      },
      {
        url: "people",
        data: "Ph.D Students",
        scroll: "phd",
      },
      {
        url: "people",
        data: "Master Students",
        scroll: "master",
      },
      {
        url: "people",
        data: "Researchers",
        scroll: "researcher",
      },
      {
        url: "people",
        data: "Interns",
        scroll: "intern",
      },
      {
        url: "people",
        data: "Ph.D Alumni",
        scroll: "alumni_phd",
      },
      {
        url: "people",
        data: "Master Alumni",
        scroll: "alumni_master",
      },
      {
        url: "people",
        data: "Former Members",
        scroll: "former",
      },
    ]
  },
  {
    firstLink: ["area", "Research"],
    secondLink: [{
        url: "area",
        data: "Teams",
        innerLink: []
      },
      {
        url: "projects",
        data: "Projects",
        innerLink: ["2022", "2021", "2020","2019","2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"]
      }
    ]
  },
  {
    firstLink: ["international", "Publication"],
    secondLink: [{
        url: "international",
        data: "International",
        innerLink: ["2022", "2021", "2020","2019","2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"]
      },
      {
        url: "domestic",
        data: "Domestic",
        innerLink: ["2022", "2021", "2020","2019","2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"]
      },
      {
        url: "thesis",
        data: "Theses",
        innerLink: ["2022", "2021", "2020","2019","2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"]
      }
    ]
  },
  {
    firstLink: ["news", "News & Event"],
    secondLink: [{
        url: "news",
        data: "News",
        innerLink: ["2022", "2021", "2020","2019","2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"]
      },
      {
        url: "media",
        data: "Media Reports",
        innerLink: ["2022", "2021", "2020","2019","2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"]
      },
      {
        url: "life",
        data: "VML Life",
        innerLink: ["2022", "2021", "2020","2019","2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"]
      }
    ]
  },
  {
    firstLink: ["seminar", "Archive", []],
    secondLink: [{
        url: "seminar",
        data: "Weekly Seminars",
        innerLink: ["2022", "2021", "2020","2019","2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"]
      },
      {
        url: "downloads",
        data: "Downloads",
        innerLink: ["2022", "2021", "2020","2019","2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"]
      }
    ]
  }
]



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/sidebar.ts